export const landFilterDefaults = {
  region_id: '',
  district_id: '',
  farmer: '',
  inn: '',
  contour_number: '',
  cadastre: '',
  reg_number: '',
  area_from: '',
  area_to: '',
  crop_id: '',
  plant_id: '',
  year: '2026',
  project_month: 'all',
  project_action_id: [],
  project_status: 'all',
};

export const landFilterFields = [
  'region_id',
  'district_id',
  'farmer',
  'inn',
  'contour_number',
  'cadastre',
  'reg_number',
  'area_from',
  'area_to',
  'crop_id',
  'page',
  'plant_id',
  'year',
  'project_month',
  'project_action_id',
  'project_status',
] as const;
